import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
export function Aprenderas() {
  const items = [<>
      Por qué el reflujo <strong data-id="element-58">no es por exceso de ácido</strong>, sino por
      déficit — y por qué este malentendido es la causa de que nunca te cures
    </>, <>
      Cómo funciona el esfínter esofágico y por qué se abre cuando no debería —
      explicado de forma simple y visual
    </>, <>
      El ciclo de fermentación-gases-presión-reflujo y cómo interrumpirlo en las
      primeras 24 horas del protocolo
    </>, <>
      Los <strong data-id="element-59">3 alimentos que creés que son saludables</strong> pero están
      destruyendo tu estómago todos los días
    </>, <>
      El método de identificación de detonantes: cómo distinguir en 48 horas qué
      activa tu reflujo específicamente
    </>, <>
      La rutina digestiva nocturna que reduce los episodios de reflujo durante
      el sueño desde la primera semana
    </>, <>
      Cómo preparar el remedio de emergencia que actúa en{' '}
      <strong data-id="element-60">3 a 5 minutos</strong> cuando el ardor aparece
    </>, <>
      El rol del estrés crónico en la producción de ácido y las estrategias
      prácticas para manejarlo
    </>, <>
      Por qué el omeprazol puede empeorar el problema a largo plazo y qué hacer
      si ya dependés de él
    </>, <>
      El plan de comidas de 72 horas: qué comer, cuándo y en qué orden para
      calmar la irritación digestiva
    </>, <>
      Los horarios de comida que más impactan en el reflujo nocturno y cómo
      ajustar tu cena sin sacrificar nada
    </>, <>
      Cuándo es necesario ver a un médico y qué señales no deben ignorarse bajo
      ningún concepto
    </>, <>
      El plan de mantenimiento post-72 horas: cómo sostener los resultados para
      que el reflujo no vuelva a controlar tu vida
    </>];
  return <section id="que-aprenderas" className="bg-crema py-[100px]" data-id="element-61">
      <div className="container-custom" data-id="element-62">
        <SectionHeader eyebrow="Contenido del ebook" title={<>
              Todo lo que vas a<br data-id="element-64" />
              aprender con el protocolo
            </>} description="El Protocolo Digestivo de 72 Horas™ te lleva de la confusión al control con información precisa y accionable." theme="light" data-id="element-63" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-12" data-id="element-65">
          {items.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx % 4 * 0.1
        }} className="flex items-start gap-4 bg-blanco p-5 rounded-[6px] border border-black/5 hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(0,0,0,0.07)] transition-all duration-200" data-id="element-66">
              <div className="shrink-0 font-display text-[22px] font-bold text-verde-claro opacity-60 leading-none min-w-[28px]" data-id="element-67">
                {(idx + 1).toString().padStart(2, '0')}
              </div>
              <div className="text-[16px] md:text-[15px] text-gris-oscuro leading-[1.6]" data-id="element-68">
                {item}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}